import { initWeb3 } from "./web3";

//const Web3 = require("web3");
const request = require("request");
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueClipboard from "vue-clipboard2";

import router from "./router";
import store from "./store";
import { getTokenInfo } from "./services/tokens";

Vue.use(VueClipboard);
Vue.config.productionTip = false;
window.ethereum.request({ method: "eth_requestAccounts" }).then((accounts) => {
  const account = accounts[0];
  console.log(account);
  initWeb3(onWeb3Ready);
});

const assetsRepoRoot =
  "https://raw.githubusercontent.com/RedTeam-Blockchain/RedTracker/main";
//const web3 = new Web3(store.state.globalConfig.networkConfig.rpcUrl);
//onWeb3Ready(web3).then();

async function onWeb3Ready(web3) {
  store.state.web3 = web3;
  const tokensFile = `${assetsRepoRoot}/token-list.json?flush_cache=True`;
  request(tokensFile, onConfigLoaded);
}

async function onConfigLoaded(error, response, body) {
  const tokensInfo = JSON.parse(body);
  for (const tokenInfo of tokensInfo) {
    const contract = new store.state.web3.eth.Contract(
      store.state.globalConfig.erc20ContractAbi,
      tokenInfo.address,
      {
        from: window.ethereum.selectedAddress,
      }
    );
    const router = new store.state.web3.eth.Contract(
      store.state.globalConfig.routerAbi,
      store.state.globalConfig.networkConfig.router,
      {
        from: window.ethereum.selectedAddress,
      }
    );
    const img = `${assetsRepoRoot}/${tokenInfo.address}.png`;

    const tokenInfoFromContract = await getTokenInfo(
      contract,
      tokenInfo.address,
      store.state.globalConfig.networkConfig.buyLinkPrefix,
      img
    );
    const pairAddress = tokenInfo.pair;
    const chartsLink = `${store.state.globalConfig.networkConfig.chartPrefix}${pairAddress}`;
    const tokenData = {
      pair: tokenInfo.pair,
      website: tokenInfo.website,
      telegram: tokenInfo.telegram,
      twitter: tokenInfo.twitter,
      charts: chartsLink,
      contract: tokenInfoFromContract.contract,
      name: tokenInfoFromContract.name,
      symbol: tokenInfoFromContract.symbol,
      totalSupplyInWei: tokenInfoFromContract.totalSupplyInWei,
      address: tokenInfo.address,
      decimals: tokenInfoFromContract.decimals,
      totalBurnedInWei: tokenInfoFromContract.totalBurnedInWei,
      totalRouterInWei: tokenInfoFromContract.totalRouterInWei,
      totalBurned: tokenInfoFromContract.totalBurned,
      percentageBurned: tokenInfoFromContract.percentageBurned,
      percentageRouter: tokenInfoFromContract.percentageRouter,
      totalSupplyFmt: tokenInfoFromContract.totalSupplyFmt,
      totalBurnedFmt: tokenInfoFromContract.totalBurnedFmt,
      buyLink: tokenInfoFromContract.buyLink,
      img: tokenInfoFromContract.img,
      holderInfo: tokenInfoFromContract.holderInfo,
      router: router,
      weth: store.state.globalConfig.networkConfig.weth,
    };
    store.state.tokens.push(tokenData);
  }

  new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
